/*eslint-disable*/
import { Menu } from 'antd';
import FeatherIcon from 'feather-icons-react';
import propTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { NavLink, useRouteMatch } from 'react-router-dom';
import { fetchPermissions } from '../redux/auth/actionCreator';
import useMenuOpenKeys from './useMenuOpenKeys';

const { SubMenu } = Menu;

function MenuItems({ darkMode, toggleCollapsed, topMenu }) {
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const openKeys = useMenuOpenKeys(topMenu);
  const { userRole, userId, isActive, permissions } = useSelector((state) => {
    return {
      userRole: state.auth.login.user?.role,
      userId: state.auth.login.user?.id,
      isActive: state.auth.login.user,
      permissions: state.permissions.permissions,
    };
  });

  useEffect(() => {
    dispatch(fetchPermissions(userId));
    const intervalId = setInterval(fetchPermissions, 5 * 60 * 1000);
    return () => clearInterval(intervalId);
  }, [userId]);

  const hasPermission = (key) => {
    if (userRole === 'Admin') {
      return true;
    }
    return permissions?.[key] || false;
  };

  const onClick = (item) => {
    if (item.keyPath.length === 1) {
      // Handle click if needed
    }
  };

  return (
    <Menu
      onOpenChange={() => {}}
      onClick={onClick}
      mode={!topMenu || window.innerWidth <= 991 ? 'inline' : 'horizontal'}
      theme={darkMode && 'dark'}
      defaultSelectedKeys={openKeys}
      defaultOpenKeys={openKeys}
      overflowedIndicator={<FeatherIcon icon="more-vertical" />}
    >
      {hasPermission('dashboard') && (
        <Menu.Item key="home" icon={!topMenu && <FeatherIcon icon="home" />}>
          <NavLink onClick={toggleCollapsed} to={`${path}`}>
            Dashboard
          </NavLink>
        </Menu.Item>
      )}

      {userRole === 'Admin' && (
        <SubMenu
          key="companies"
          icon={!topMenu && <FeatherIcon icon="users" />}
          title={<span style={{ marginLeft: '20px' }}>Clients</span>}
        >
          {hasPermission('createCompanies') && (
            <Menu.Item key="createCompanies">
              <NavLink onClick={toggleCollapsed} to={`${path}/companies/v1/create`}>
                Add Client
              </NavLink>
            </Menu.Item>
          )}

          <Menu.Item key="companiesList">
            <NavLink onClick={toggleCollapsed} to={`${path}/companies/v1/overview`}>
              Clients
            </NavLink>
          </Menu.Item>
        </SubMenu>
      )}

      {(hasPermission('createAgent') || hasPermission('createCompany')) && (
        <SubMenu
          key="users"
          icon={!topMenu && <FeatherIcon icon="users" />}
          title={<span style={{ marginLeft: '20px' }}>Agents</span>}
        >
          {hasPermission('createCompany') && (
            <Menu.Item key="company">
              <NavLink onClick={toggleCollapsed} to={`${path}/company/create`}>
                Create AI Agent
              </NavLink>
            </Menu.Item>
          )}

          <Menu.Item key="agent-list">
            <NavLink onClick={toggleCollapsed} to={`${path}/user/agent/list`}>
              Human Agents
            </NavLink>
          </Menu.Item>
        </SubMenu>
      )}

      {hasPermission('conversationList') && (
        <Menu.Item key="conversation" icon={!topMenu && <FeatherIcon icon="message-square" />}>
          <NavLink onClick={toggleCollapsed} to={`${path}/conversations/log?from=Facebook`}>
            Conversations
          </NavLink>
        </Menu.Item>
      )}

      {(hasPermission('newTicket') || hasPermission('ticketList')) && (
        <SubMenu
          key="ticket"
          icon={!topMenu && <FeatherIcon icon="file-text" />}
          title={<span style={{ marginLeft: '20px' }}>Support Tickets</span>}
        >
          {hasPermission('ticketList') && (
            <Menu.Item key="list">
              <NavLink onClick={toggleCollapsed} to={`${path}/ticket`}>
                Ticket List
              </NavLink>
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {/* New Feature 11/07/26*/}
      <Menu.Item key="crm" icon={!topMenu && <FeatherIcon icon="book-open" />}>
        <NavLink onClick={toggleCollapsed} to={`${path}/crm/table`}>
          CRM
        </NavLink>
      </Menu.Item>
      {/* New Feature end */}
      {(hasPermission('campaign') || hasPermission('createCampaign')) && (
        <SubMenu
          key="campaign"
          icon={!topMenu && <FeatherIcon icon="file-text" />}
          title={<span style={{ marginLeft: '20px' }}>Campaigns</span>}
        >
          {hasPermission('createCampaign') && (
            <Menu.Item key="createCampaign">
              <NavLink onClick={toggleCollapsed} to={`${path}/campaign/whatsapp-campaign`}>
                Create New Campaign
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('campaignList') && (
            <Menu.Item key="campaignList">
              <NavLink onClick={toggleCollapsed} to={`${path}/campaign/list`}>
                WhatsApp Campaigns
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('outboundCallList') && (
            <Menu.Item key="outboundCallList">
              <NavLink onClick={toggleCollapsed} to={`${path}/campaign/list/outbound-call`}>
                Outbound Campaigns
              </NavLink>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {hasPermission('appointment') && (
        <Menu.Item key="appointment" icon={!topMenu && <FeatherIcon icon="calendar" />}>
          <NavLink onClick={toggleCollapsed} to={`${path}/appointment`}>
            Appointments
          </NavLink>
        </Menu.Item>
      )}

      {hasPermission('products') && (
        <Menu.Item key="products" icon={!topMenu && <FeatherIcon icon="shopping-cart" />}>
          <NavLink onClick={toggleCollapsed} to={`${path}/products/orders`}>
            Products & Orders
          </NavLink>
        </Menu.Item>
      )}

      {hasPermission('knowledgebase') && (
        <Menu.Item key="knowledgebase" icon={!topMenu && <FeatherIcon icon="book-open" />}>
          <NavLink onClick={toggleCollapsed} to={`${path}/knowledge/add-knowledge`}>
            Knowledge Base
          </NavLink>
        </Menu.Item>
      )}

      {(hasPermission('aiInstructions') || hasPermission('thirdPartyAPI')) && (
        <SubMenu
          key="integrations"
          icon={!topMenu && <FeatherIcon icon="cpu" />}
          title={<span style={{ marginLeft: '20px' }}>Integration</span>}
        >
          {userRole === 'Admin' && (
            <Menu.Item key="campaignInstructionTemplates">
              <NavLink onClick={toggleCollapsed} to={`${path}/integration/campaign-templates`}>
                Campaign Templates
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('aiInstructions') && (
            <Menu.Item key="aiinstruction">
              <NavLink onClick={toggleCollapsed} to={`${path}/integration/instruction`}>
                Custom Instructions
              </NavLink>
            </Menu.Item>
          )}
          {userRole === 'Admin' && (
            <Menu.Item key="addInstruction">
              <NavLink onClick={toggleCollapsed} to={`${path}/instructions/default/non-voice`}>
                Agent Policies
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('thirdPartyAPI') && (
            <Menu.Item key="thirdPartyAPI">
              <NavLink onClick={toggleCollapsed} to={`${path}/integration/api-credentials`}>
                API Integrations
              </NavLink>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {(hasPermission('domainApproval') || hasPermission('snippet')) && (
        <SubMenu
          key="deployment"
          icon={<FeatherIcon icon="upload-cloud" />}
          title={<span style={{ marginLeft: '20px' }}>Deployment</span>}
        >
          {hasPermission('domainApproval') && (
            <Menu.Item key="domainapproval">
              <NavLink onClick={toggleCollapsed} to={`${path}/deployment/domain/approval`}>
                Domain Verification
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('domainApproval') && (
            <Menu.Item key="domainApproval">
              <NavLink onClick={toggleCollapsed} to={`${path}/deployment/domain/channel-list`}>
                Channel List
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('snippet') && (
            <Menu.Item key="widget">
              <NavLink onClick={toggleCollapsed} to={`${path}/deployment/widget/web`}>
                Widget
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('googleSheets') && (
            <Menu.Item key="google-sheets">
              <NavLink onClick={toggleCollapsed} to={`${path}/deployment/google-sheets/connect`}>
                Google Sheets
              </NavLink>
            </Menu.Item>
          )}
        </SubMenu>
      )}

      {userRole === 'Admin' && (
        <SubMenu
          key="billing"
          icon={<FeatherIcon icon="settings" />}
          title={<span style={{ marginLeft: '20px' }}>Settings</span>}
        >
          {hasPermission('accessControl') && (
            <Menu.Item key="access-control">
              <NavLink onClick={toggleCollapsed} to={`${path}/settings/access-control`}>
                Access Control
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('accessibility') && (
            <Menu.Item key="accessibility">
              <NavLink onClick={toggleCollapsed} to={`${path}/settings/accessibility`}>
                Accessibility
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('billing') && (
            <Menu.Item key="billing">
              <NavLink onClick={toggleCollapsed} to={`${path}/settings/billing`}>
                Billing
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('log') && (
            <Menu.Item key="logs">
              <NavLink onClick={toggleCollapsed} to={`${path}/settings/logs`}>
                Logs
              </NavLink>
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {(hasPermission('services') || hasPermission('packages') || hasPermission('add-package')) && (
        <SubMenu key="studio" icon={<FeatherIcon icon="package" />} title="Services">
          {hasPermission('packages') && (
            <Menu.Item key="packages">
              <NavLink onClick={toggleCollapsed} to={`${path}/billing/packages`}>
                Packages
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('log') && (
            <Menu.Item key="add-package">
              <NavLink onClick={toggleCollapsed} to={`${path}/billing/add-package`}>
                Add New
              </NavLink>
            </Menu.Item>
          )}
        </SubMenu>
      )}
      {(hasPermission('coupon') || hasPermission('couponlist') || hasPermission('addcoupon')) && (
        <SubMenu key="studio" icon={<FeatherIcon icon="tag" />} title="Coupon">
          {hasPermission('addcoupon') && (
            <Menu.Item key="create-new">
              <NavLink onClick={toggleCollapsed} to={`${path}/coupons/create/new`}>
                Create New
              </NavLink>
            </Menu.Item>
          )}
          {hasPermission('couponlist') && (
            <Menu.Item key="coupon-list">
              <NavLink onClick={toggleCollapsed} to={`${path}/coupons/overview`}>
                Coupon List
              </NavLink>
            </Menu.Item>
          )}
        </SubMenu>
      )}
    </Menu>
  );
}

MenuItems.propTypes = {
  darkMode: propTypes.bool,
  topMenu: propTypes.bool,
  toggleCollapsed: propTypes.func,
};

export default MenuItems;
